import { useState, useEffect } from 'react';
import axios from 'axios';

export const useMappedInSettings = (userId) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Default fallback configuration
  // const DEFAULT_CONFIG = {
  //   key: 'mik_gxWE7PUdHxoK9qNlr555107ac',
  //   secret: 'mis_hvx40sGJZ2cuyzSDEHv55PtldjuszH20dVqhRkBV8R597271073',
  //   mapId: '69709560a8a681000bf10352',
  // };

  useEffect(() => {
    const fetchSettings = async () => {
      if (!userId) {
        // setSettings(DEFAULT_CONFIG);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await axios.get(`/api/wayfinder/mappedin-settings/${userId}`);

        if (response.data.success && response.data.data) {
          const data = response.data.data;

          // If enabled and has valid credentials, use them
          if (data.enabled && data.apiKey && data.apiSecret && data.mapId) {
            setSettings({
              key: data.apiKey,
              secret: data.apiSecret,
              mapId: data.mapId,
              usePointrMap: data.usePointrMap || false,
              startLocation: data.startLocation || null,
              mapLink: data.mapLink || '',
              mappedInStartLocation: data.mappedInStartLocation || '',
              mappedInStartLocationName: data.mappedInStartLocationName || '',
            });
          } else {
            // Store mapLink even if not fully configured
            setSettings({
              key: '',
              secret: '',
              mapId: '',
              usePointrMap: false,
              startLocation: null,
              mapLink: data.mapLink || '',
              mappedInStartLocation: '',
              mappedInStartLocationName: '',
            });
          }
        } else {
          setSettings({
            key: '', secret: '', mapId: '', usePointrMap: false, startLocation: null, mapLink: '', mappedInStartLocation: '',
            mappedInStartLocationName: '',
          });
        }
      } catch (err) {
        console.error('Error fetching MappedIn settings:', err);
        setError(err.message);
        setSettings({ key: '', secret: '', mapId: '', usePointrMap: false, startLocation: null, mapLink: '', mappedInStartLocation: '',
            mappedInStartLocationName: '' });
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, [userId]);

  return { settings, loading, error };
};
